import { format } from "date-fns";
import { Fragment, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { Calendar } from "../../../../ui/molecules/calendar";
import { SearchType } from "../../../../ui/molecules/input/Input.types";
import InputSearch from "../../../../ui/molecules/input/InputSearch";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { ProtocolSearch } from "../../../../ui/molecules/ProtocolSearch";
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static";
import TextArea from "../../../../ui/molecules/textArea";
import { OptionType } from "../../../../utils";
import { GetAllOdc, resetGetAllOdcStatus } from "../../../odc/slice";
import { GetByIdPersonalManagement } from "../../slice";
import { CDXM026Update, CDXM026Validation, resetCDXM026Errors, resetCDXM026UpdateRequest, resetCDXM026UpdateStatus, resetCDXM026ValidationStatus, setUpdateCDXClientRelationshipType, setUpdateCDXEndingDate, setUpdateCDXNote, setUpdateCDXOperator, setUpdateCDXOperatorRelationshipType, setUpdateCDXProtocolIdEntry, setUpdateCDXStartingDate, setUpdateCDXSupervisory } from "../slice";

interface Props {
    close: () => void;
}

export function CDXM026PopupEdit(props: Props) {
    const dispatch = useAppDispatch()
    const CDXM026State = useAppSelector(state => state.PMCDXM026)
    const PMState = useAppSelector(state => state.personalManagement)
    const odcState = useAppSelector(state => state.odc)
    const [odc, setOdc] = useState<OptionType[]>([])

    useEffect(() => {
        dispatch(GetAllOdc({ itemsPerPage: 0, page: 0 }))
    }, [])

    useEffect(() => {
        if (odcState.getAllOdcStatus === 'successfully' && odcState.getAllOdcResponse !== undefined) {
            dispatch(resetGetAllOdcStatus())
            const data = odcState.getAllOdcResponse.data.map(odc => ({
                value: odc.id,
                label: odc.companyName,
            } as OptionType))
            setOdc(data)
        }
    }, [odcState.getAllOdcStatus])

    useEffect(() => {
        if (CDXM026State.CDXM026ValidationStatus === 'successfully') {
            dispatch(resetCDXM026ValidationStatus())
            dispatch(resetCDXM026Errors())
            dispatch(CDXM026Update({ body: CDXM026State.CDXM026UpdateRequest, id: CDXM026State.CDXM026IdToUpdate }))
        }
    }, [CDXM026State.CDXM026ValidationStatus])

    useEffect(() => {
        if (CDXM026State.CDXM026UpdateStatus === 'successfully') {
            dispatch(resetCDXM026UpdateRequest())
            dispatch(resetCDXM026UpdateStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
            props.close()
        }
    }, [CDXM026State.CDXM026UpdateStatus])

    return (
        <Fragment>
            <div className="p-6 bg-white flex flex-col gap-6">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1">
                        <InputSearch
                            error={CDXM026State.CDXM026Errors.client}
                            supportingText={CDXM026State.CDXM026Errors.client ? 'Cliente mancante od operatore già presente' : undefined}
                            label="Seleziona Cliente"
                            placeholder="Specifica cliente..."
                            searchType={SearchType.COMPANY_NAME}
                        />
                        {CDXM026State.CDXM026CompanyName && (
                            <span className="label-search-code text-brandPrimary-700 text-sm">
                                {`${CDXM026State.CDXM026UpdateRequest.client} - ${CDXM026State.CDXM026CompanyName}`}
                            </span>
                        )}
                    </div>
                    <MadfarmInput
                        label="Tipologia Rapporto"
                        placeholder="Specifica tipologia..."
                        value={CDXM026State.CDXM026UpdateRequest.clientRelationshipType}
                        defaultValue={CDXM026State.CDXM026UpdateRequest.clientRelationshipType}
                        onChangeText={(text) => dispatch(setUpdateCDXClientRelationshipType(text))}
                        error={CDXM026State.CDXM026Errors.clientRelationshipType}
                        supportingText={CDXM026State.CDXM026Errors.clientRelationshipType ? 'Rapporto mancante od operatore già presente' : undefined}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Per i clienti non assoggettati a Codex
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmInput
                        label="Operatore non assoggettato"
                        placeholder="Specifica operatore..."
                        value={CDXM026State.CDXM026UpdateRequest.operator}
                        defaultValue={CDXM026State.CDXM026UpdateRequest.operator}
                        onChangeText={(text) => dispatch(setUpdateCDXOperator(text))}
                        error={CDXM026State.CDXM026Errors.operator}
                        supportingText={CDXM026State.CDXM026Errors.operator ? 'Operatore mancante o cliente già presente' : undefined}
                    />
                    <MadfarmInput
                        label="Tipologia Rapporto"
                        placeholder="Specifica tipologia..."
                        value={CDXM026State.CDXM026UpdateRequest.operatorRelationshipType}
                        defaultValue={CDXM026State.CDXM026UpdateRequest.operatorRelationshipType}
                        onChangeText={(text) => dispatch(setUpdateCDXOperatorRelationshipType(text))}
                        error={CDXM026State.CDXM026Errors.operatorRelationshipType}
                        supportingText={CDXM026State.CDXM026Errors.operatorRelationshipType ? 'Rapporto mancante o cliente già presente' : undefined}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Organismo di controllo"
                        placeholder="Seleziona organismo..."
                        options={odc}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setUpdateCDXSupervisory(newValue))
                        }}
                        defaultValue={CDXM026State.CDXM026UpdateRequest.odcId}
                        value={CDXM026State.CDXM026UpdateRequest.odcId}
                        error={CDXM026State.CDXM026Errors.odc}
                        errorLabel={CDXM026State.CDXM026Errors.odc ? 'ODC mancante o cliente già presente' : undefined}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">
                        Altri dati
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-6">
                    <ProtocolSearch
                        type="entry"
                        defaultValue={CDXM026State.CDXM026UpdateRequest.protocolIdEntry}
                        onSelect={(value) => dispatch(setUpdateCDXProtocolIdEntry(value))}
                    />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <Calendar
                        label="Data inizio"
                        selected={CDXM026State.CDXM026UpdateRequest.starting}
                        onChange={(date) => dispatch(setUpdateCDXStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                    <Calendar
                        label="Data fine"
                        selected={CDXM026State.CDXM026UpdateRequest.ending}
                        onChange={(date) => dispatch(setUpdateCDXEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Note"
                        defaultValue={CDXM026State.CDXM026UpdateRequest.note}
                        value={CDXM026State.CDXM026UpdateRequest.note}
                        onChangeText={(text) => dispatch(setUpdateCDXNote(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => {
                            dispatch(resetCDXM026Errors())
                            dispatch(resetCDXM026UpdateRequest())
                            props.close()
                        }}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(CDXM026Validation(CDXM026State.CDXM026UpdateRequest))
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}